<template>
	<div class="face_track">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">活体视频检测与追踪</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			对视频流的BGR24数据进行活体检测、追踪。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">int __stdcall SKFaceVideoLiveDetect(int nTrackID, unsigned char* pBGR24Data, int nWidth, int nHeight);</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）nTrackID: 要进行活体检测的人脸ID</p>
        <p class="doc_main_p">（2）pBGR24Data: 视频帧的BGR倒立数据</p>
        <p class="doc_main_p">（3）nWidth: 视频帧宽度</p>
        <p class="doc_main_p">（4）nHeight: 视频帧高度</p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	int类型，1为活体；0为非活体；-1正在识别；-2未初始化SDK
		</p>
		<h3 class="doc_main_h3">示例代码</h3>
        <pre class="doc_main_pre"><code class="doc_main_code">int nTrackID = 0;   // 通过视频检测获取人脸的TrackID
int nRet = SKFaceVideoLiveDetect(nTrackID,pBGR24Data,1920,1080);
</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFaceLive-Windows','基础接口','活体视频检测与追踪'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.face_track{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacelivewindows/basics/faceLiveTrack.vue